import { IonInput as IonicIonInput } from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '../theme'

export const IonInput = styled(IonicIonInput)`
  && {
    --background: ${myPalette.white.main};
    --border-color: ${myPalette.blue.lightSteelBlue};
    --border-width: 1px !important;
    --padding-start: 16px;
    --border-radius: 6px;
    --highlight-color-focused: ${myPalette.blue.main};
    --highlight-color: ${myPalette.blue.main};
    --highlight-color-valid: ${myPalette.blue.main};
    --color: ${myPalette.blue.lightSteelBlue};

    --highlight-color-invalid: ${myPalette.red.main};

    input {
      color: ${myPalette.midnightBlue.main};
    }
  }

  &&:hover,
  &&:focus,
  &&:active {
    --border-color: ${myPalette.blue.main};
    --color: ${myPalette.blue.main};
  }

  .input-bottom {
    padding: 2px 0 0;
  }

  .label-text {
    transform: translateY(-3px);
  }
`
